import { gql } from '@apollo/client';

export const FETCH_USER_NAME = ({
  canReadClientLowRiskPii,
}: {
  canReadClientLowRiskPii: boolean;
}) => gql`
  query fetchUserName($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        entityName # for NonIndividual Clients from Households route
        ${canReadClientLowRiskPii ? 'firstName' : ''}
        ${canReadClientLowRiskPii ? 'middleName' : ''}
        ${canReadClientLowRiskPii ? 'lastName' : ''}
      }
    }
  }
`;
